import {UPDATE_FILED, CLEAR} from "./Actions";

const defaultState = {
   postCategories: [],
   postCategoriesLoad: false,
   productCategories: [],
   productCategoriesLoad: false,
   genres: [],
   genresLoad: false,
   languages: [],
   languagesLoad: false,
   users: [],
   usersLoad: false,
   abilities: [],
   abilitiesLoad: false,
   roles: [],
   rolesLoad: false,
   cafes: [],
   cafesLoad: false,
   activityFields: [],
   activityFieldsLoad: false,
   countries: [],
   countriesLoad: false,
   series: [],
   seriesLoad: false,
   seasons: [],
   seasonsLoad: false,
   casts: [],
   castsLoad: false,
   productOwners: [],
   productOwnersLoad: false,
   sliders: [],
   slidersLoad: false,
   menus: [],
   menusLoad: false,

   parentMenuItems: [],
   parentMenuItemsLoad: false,

   products: [],
   productsLoad: false,
   festivals: [],
   festivalsLoad: false,
   packages: [],
   packagesLoad: false,
   globalSearch: {
      users: [],
      products: [],
      festivals: [],
      packages: []
   },
   globalSearchLoad: false,
   crmUser:null,
   crmLoad:false,
   crmSearch:[]
};

export default (state = defaultState, {type, payload}) => {
   switch (type) {
      case UPDATE_FILED:
         return {
            ...state,
            [payload.prop]: payload.value,
         };
      case CLEAR:
         return {...defaultState};
      default:
         return state;
   }
};
